import Analyses from './Analyses';

export default Analyses;
